import React from 'react';

const toneStyles = {
  ok: 'border-[#00C27A]/60 text-[#00C27A]',
  warn: 'border-[#FFB800]/60 text-[#FFB800]',
  alert: 'border-[#D71921]/70 text-[#D71921]',
  neutral: 'border-white/15 text-neutral-400',
  info: 'border-[#00D4FF]/60 text-[#00D4FF]',
};

const StatusPill = ({ tone = 'neutral', children, pulse = false }) => (
  <span className={`inline-flex items-center gap-2 px-2 py-1 border font-mono-tech text-[9px] uppercase tracking-[0.2em] ${toneStyles[tone]}`}>
    {pulse && <span className={`w-1.5 h-1.5 ${tone === 'alert' ? 'bg-[#D71921]' : tone === 'warn' ? 'bg-[#FFB800]' : 'bg-[#00C27A]'} animate-pulse rounded-full`} />}
    {children}
  </span>
);

export default StatusPill;
